// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1EfC6","inner":"styles_inner__19EbS"};